import { Component, OnDestroy, OnInit, Input, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { CompanyProfileCreateOrEditDto, CompanyProfileServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { KekaAccessService } from '@app/admin/keka-manager-approvals/keka-access.service';

@Component({
  standalone: false,
  selector: 'app-setting-topbar',
  templateUrl: './setting-topbar.component.html',
  styleUrls: ['./setting-topbar.component.scss']
})
export class SettingTopbarComponent extends AppComponentBase implements OnInit, OnDestroy {
    imagePath: string;
    profilePicture: string;
    companyName = '';
    companyProfile: CompanyProfileCreateOrEditDto = new CompanyProfileCreateOrEditDto();
    @Input() customStyle = 'btn btn-icon btn-dropdown btn-clean mr-1 mt-0';
    @Input() isDropup = false;
    isLoginForFirstTime: boolean = false;
    canViewKeka = false;
    checkLogin: string;
    webAppVersion:string;
    private readonly checkLoginForTopbarSettingHandler = () => this.userQuickStartDetailsCheckSetting();

    constructor(private router: Router,
        private _companyProfilesServiceProxy: CompanyProfileServiceProxy,
        private _abpSession: AbpSessionService,
        public _appSession: AppSessionService,

        private _kekaAccess: KekaAccessService,
        injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this._kekaAccess.get().subscribe(access => this.canViewKeka = access.canView);

        abp.event.on('checkLoginForTopbarSetting', this.checkLoginForTopbarSettingHandler);
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));

    }

    ngOnDestroy(): void {
        abp.event.off('checkLoginForTopbarSetting', this.checkLoginForTopbarSettingHandler);
    }

    userQuickStartDetailsCheckSetting() {
        this.webAppVersion= this._appSession.webAppVersion;

        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
    }

    onSettingsOpenChange(isOpen: boolean): void {
        if (isOpen) {
            this.updateInfoForCompanyProfile();
        }
    }

    updateInfoForCompanyProfile() {
        if (!AppConsts?.companyDetails) {
            if (abp.session.tenantId) {
                this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(abp.session.tenantId).subscribe(x => {
                    if (x.companyImgURL !== null || x.companyImgURL !== undefined) {
                        this.profilePicture = x.companyImgURL;
                        this.companyImgURL = x.companyImgURL;
                    }
                    this.companyName = x.companyName;
                    AppConsts.companyDetails = x;
                });
            }

            else {
                this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(undefined).subscribe(x => {
                    if (x.companyImgURL !== null || x.companyImgURL !== undefined) {
                        this.profilePicture = x.companyImgURL;
                        this.companyImgURL = x.companyImgURL;
                    }
                    this.companyName = x.companyName;
                    AppConsts.companyDetails = x;
                });
            }
        } else {
            if (AppConsts?.companyDetails.companyImgURL !== null || AppConsts?.companyDetails.companyImgURL !== undefined) {
                this.profilePicture = AppConsts?.companyDetails.companyImgURL;
                this.companyImgURL = AppConsts?.companyDetails.companyImgURL;
            }
            this.companyName = AppConsts?.companyDetails.companyName;
        }
    }

    companyImgURL:string = null;
    getCompanyProfileDetails() {
        if (!AppConsts?.companyDetails) {
            this._companyProfilesServiceProxy.getCompanyProfileDetailsForEditView(this._abpSession.tenantId).subscribe(res => {
            this.companyImgURL = res.companyImgURL; AppConsts.companyDetails = res;
            });
        } else {
            this.companyImgURL = AppConsts?.companyDetails?.companyImgURL;
        }
    }

    getCompanyProfileImg() {
        this._companyProfilesServiceProxy.getAllCompanyProfile().subscribe(res => {

            this.companyProfile = res;
            this.profilePicture = '';
            if (res.companyLogoURL !== undefined) {
                this.profilePicture = res.companyLogoURL;
            }
            this.companyProfile.dateFormat = res.dateFormat;
            this.companyProfile.id = res.id;
        });
    }
    addNewUser() {
        this.router.navigate([AppRoutes.admin.users]);
    }
    getCompanyProfile() {
        this.router.navigate([AppRoutes.companyProfile]);
    }
    getProductAndServiceNew() {
        this.router.navigate([AppRoutes.productsAndServices]);
    }

    getOrganizationUnit() {
        this.router.navigate([AppRoutes.admin.organizationUnits]);
    }

    getMangeUser() {
        this.router.navigate([AppRoutes.admin.users]);
    }

    /** Opens the Keka page (three Keka tabs only); the link shows only for Keka approvers and super admins. */
    getKeka() {
        this.router.navigate(['/admin/keka']);
    }
    getAppCategory() {
        this.router.navigate([AppRoutes.appCategory]);
    }
    getMasters() {
        this.router.navigate([AppRoutes.masters]);
    }

    imageLoad(){
    }
}
